import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BcCircleLoadingComponent } from '@bancolombia/design-system-web/bc-circle-loading';
import { BcInputFileComponent } from '@bancolombia/design-system-web/bc-input-file';
import { BcModalComponent } from '@bancolombia/design-system-web/bc-modal';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ArchivoAdjuntoUpload, ArchivoAdjuntoUploadResponseModel } from 'src/app/domain/models/archivo-adjunto/archivo-adjunto-upload.model';
import { AzureAdAccountModel } from 'src/app/domain/models/azure-ad/account.model';
import { ErrorModel } from 'src/app/domain/models/error/error.model';
import { FacturaContentModel } from 'src/app/domain/models/factura/factura.model';
import { ArchivoAdjuntoUseCase } from 'src/app/domain/usecases/archivo-adjunto/archivo-adjunto.usecase';
import { FacturaUseCase } from 'src/app/domain/usecases/factura/factura.usecase';
import { FacturaDetalleComponent } from 'src/app/ui/pages/factura/factura-detalle/factura-detalle.component';


@Component({
  selector: 'subir-archivo-adjunto',
  templateUrl: './subir-archivo-adjunto.component.html',
  styleUrls: ['./subir-archivo-adjunto.component.css']
})
export class SubirArchivoAdjuntoComponent implements OnInit {

  @Input('facturaDetalleComponent') facturaDetalleComponent!: FacturaDetalleComponent;

  @Input('dataFactura') dataFactura: FacturaContentModel;

  @Input('loading') bcCircleLoading!: BcCircleLoadingComponent;

  @ViewChild('InputFileDetalleFactura')
  inputInstace!: BcInputFileComponent;

  @ViewChild('confirmacion', { static: false })
  confirmacionModal!: BcModalComponent;

  archivo: string;
  extensionesPermitidas: string = "xlsx";
  maxArchivos: number = 1;
  username: string;
  azureAccount: Observable<AzureAdAccountModel>;
  //Usuario del sistema por defecto cuando no hay una autenticacion con Azure AD
  nombreTest = 'system';
  // modal Confirmacion
  confirmAction: boolean = true;
  confirmDisplayButton: boolean = true;
  confirmOuterCloseTap: boolean = true;
  confirmSubTitle = 'Realmente desea adjuntar el documento?';
  confirmButtonAlignment: any = 'horizontal';
  //fin modal Confirmacion


  constructor(
    private archivoAdjuntoUseCase: ArchivoAdjuntoUseCase,
    private store: Store,
    private facturaUseCase: FacturaUseCase
  ) {
    this.archivo = '';
    //Obtiene informacion de la Store
    this.azureAccount = this.store.select(state => state.account);
    this.username = '';
    this.dataFactura = {
      numero_factura: '',
      ciudad: null,
      remitente: '',
      nit: '',
      fecha_creacion: new Date(),
      estado: {
        nombre: '',
        codigo: ''
      },
      retieca: '',
      reteiva: '',
      retefuente: '',
      total_acticipos: 0,
      iva: '',
      total_antes_impuestos: 0,
      total_incl_impuestos: 0,
      razons_adquiriente: '',
      nit_adquiriente: '',
      ciuAdquiriente: '',
      depEmision: ''
    };
  }

  ngOnInit(): void {
    this.obtenerAzureAccountUsername();
  }


  obtenerAzureAccountUsername(): void {
    this.azureAccount.subscribe({
      next: data => {
        this.username = data.username == null ? this.nombreTest : data.username!;
      }
    });
  }

  metodoParaCogerLosArchivos(archivos: File[]) {
    if (archivos.length > 0) {
      const file = archivos[0];
      this.convertFileToBase64(file).then(base64 => {
        this.archivo = base64;
      })
    } else {
      this.archivo = "";
    }

  }

  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result as string);
      }
      reader.onerror = error => {
        reject(error);
      }
    });
  }

  confirmarAdjuntarArchivo() {
    this.confirmacionModal.openModal();
  }

  // Modal Confirmacion cambio de estado si/no
  onPressButton(event: any) {
    switch (Number(event)) {
      case 0: {
        this.confirmacionModal.shutDown();
      }
        break;
      case 1: {
        this.confirmacionModal.shutDown();
        this.subirArchivo();
      }
        break;
    }
  }

  subirArchivo() {
    this.bcCircleLoading.showCircleLoading();

    let file = this.limpiarBase64(this.archivo);

    this.archivoAdjuntoUseCase.upload(this.construirArchivoAdjuntoUpload(file))
      .subscribe({
        next: (data: ArchivoAdjuntoUploadResponseModel) => {
          this.bcCircleLoading.hideCircleLoading();
          this.facturaUseCase.openAlert('success', 'Archivo subido de forma exitosa', data.message, 5000);
          this.limpiarFormulario();
          this.facturaDetalleComponent.consultarFactura();
        },
        error: (response: ErrorModel) => {
          this.bcCircleLoading.hideCircleLoading();
          let mensaje = response.error.message;
          this.archivoAdjuntoUseCase.openAlert('error', 'Error de sistema', mensaje, 5000);
          this.limpiarFormulario();
        }
      });
  }

  construirArchivoAdjuntoUpload(base64File: string): ArchivoAdjuntoUpload {
    return {
      base64File: base64File,
      factura: this.dataFactura.numero_factura,
      usuario: this.username,
    }
  }

  limpiarBase64(archivo: string): string {
    let arrFile = archivo.split(',');
    return arrFile[1];
  }

  limpiarFormulario() {
    const uploadedFilesMainContainer = this.inputInstace.bcInputFileBehavior.uploadedFilesMainContainer;

    if (uploadedFilesMainContainer) {
      const fileButton = uploadedFilesMainContainer.querySelector('.file-button');

      if (fileButton) {
        fileButton.click();
      } else {
        console.log('No se encontró el botón de archivo');
      }
    } else {
      console.log('No se encontró el contenedor de archivos subidos');
    }
  }

}
